@if (images?.length > 0) {
<div
  class="gallery-container"
  (keydown)="onKeydown($event)"
  (touchstart)="onTouchStart($event)"
  (touchend)="onTouchEnd($event)"
  (mousedown)="onMouseDown($event)"
  (mouseup)="onMouseUp($event)"
  (mouseleave)="onMouseLeave()"
  tabindex="0"
>
  <button class="nav-button left" (click)="previousImage()" [disabled]="currentImageIndex === 0" [attr.aria-label]="'shared.previousImage' | translate">
    <i class="icon icon-chevron-left"></i>
  </button>

  @if (currentImage) {
  <img class="main-image" [src]="currentImage.url" [alt]="currentImage.alt" />
  }

  <button
    class="nav-button right"
    (click)="nextImage()"
    [disabled]="currentImageIndex === images.length - 1"
    [attr.aria-label]="'shared.nextImage' | translate"
  >
    <i class="icon icon-chevron-right"></i>
  </button>

  <div class="thumbnail-wrapper mb-2">
    <button
      *ngFor="let image of images; let i = index"
      class="thumbnail-btn"
      [class.active]="i === currentImageIndex"
      [attr.aria-selected]="i === currentImageIndex"
      (click)="selectImage(i)"
    >
      <img [src]="image.url" [alt]="'wcag.imageGallery.miniatureImageLabel' | translate : { count: i + 1, maxCount: images.length, description: image.alt }" />
    </button>
  </div>
</div>
}
